import WithAuth from "../components/hoc/with-auth"
import { LayoutWithSidebar } from "../components/layouts/layout-with-sidebar.tsx"
import MostProfitablePage from "../components/pages/most-profitable"
import MostLossesPage from "../components/pages/most-profitable-loss"

const MostLosses = () => {
  return (
    <>
      <WithAuth>
        <LayoutWithSidebar
          pageTitle="Most Losses Trades"
          pageDesc="List of all the most losses trades"
        >
          <MostLossesPage />
        </LayoutWithSidebar>
      </WithAuth>
    </>
  )
}

export default MostLosses
